import * as React from "react";
const SvgBulk20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M10 1a5 5 0 0 1 5 5h4v13H1V6h4a5 5 0 0 1 5-5ZM7 6h6a3 3 0 1 0-6 0Z",
      clipRule: "evenodd"
    })
  );
export default SvgBulk20Px;
